export const PERMISSIONS = {
  WEB_ACCESO: 'WEB_ACCESO',
  WEB_ACCESO_PEDIDOS: 'WEB_ACCESO_PEDIDOS',
  WEB_ACCESO_AVISOS: 'WEB_ACCESO_AVISOS',
  WEB_PEDIDOS_TODOS: 'WEB_PEDIDOS_TODOS',
  WEB_PEDIDOS_PAIS: 'WEB_PEDIDOS_PAIS',
  WEB_CREAR_SABANA: 'WEB_CREAR_SABANA',
}
